import { ApplicationConfigurationService } from './../../application-configuration/application-configuration.service';
import { SnapshotService } from './../../snapshot/snapshot.service';
import { ConstantValue } from './../../common/constant-value';
import { Component, OnInit } from '@angular/core';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { AppConfig } from '../../app.config';
import { UserProfile } from '@liquitics/transaction';
import { convertFromConstantToHuman } from '@liquitics/transaction';

import { MatDialogRef } from '@angular/material/dialog';
import { CognitoUtil } from '../../authentication/cognito.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-switch-profile',
    templateUrl: './switch-profile.component.html',
    styleUrls: ['./switch-profile.component.css']
})
export class SwitchProfileComponent implements OnInit {

    profiles: ConstantValue[] = [];
    selectedProfileKey: string;
    switchResult: string;

    constructor(
        private cognitoUtil: CognitoUtil,
        private snapshotService: SnapshotService,
        private appConfig: AppConfig,
        private dashboardEventService: DashboardEventService,
        private applicationConfigurationService: ApplicationConfigurationService,
        private messageService: MessageService,
        public dialogRef: MatDialogRef<SwitchProfileComponent>) {
        try {
            this.profiles = snapshotService.applicationConfiguration.userProfiles.map((userProfile: UserProfile) => {
                let displayValue = convertFromConstantToHuman(userProfile.getProfileType());
                if (displayValue !== 'Operations') {
                    if (userProfile.getCurrencies() && userProfile.getCurrencies().length > 0 && userProfile.getCurrencies().length < 3) {
                        displayValue += ' (' + userProfile.getCurrencies().join(',') + ')';
                    }
                }
                return new ConstantValue(this.generateProfileKey(userProfile), displayValue);
            });
            if (snapshotService.applicationConfiguration.hasLiquiticsAdminAccess) {
                this.profiles.push(new ConstantValue('LIQUITICS_ADMINISTRATION', 'Liquitics Administration'));
            }
            this.selectedProfileKey = this.generateProfileKey(this.appConfig.activeUserProfile);
        } catch (err) {
            this.messageService.add({ severity: 'error', summary: 'Unexpected Error', detail: err });
        }
    }

    ngOnInit() {
    }

    switchProfile() {
        if (this.selectedProfileKey === 'LIQUITICS_ADMINISTRATION') {
            const referenceUrl = this.appConfig.getTenantInfo().adminApplicationUrl;
            const clientId = this.appConfig.getTenantInfo().clientId;
            const region = this.appConfig.getTenantInfo().region;
            const userPoolId = this.appConfig.getTenantInfo().userPoolId;
            this.cognitoUtil.getIdToken()
                .then((token: string) => {
                    window.open(`${referenceUrl}/token-login?id_token=${token}&client_id=${clientId}&region=${region}&user_pool_id=${userPoolId}`, '_blank');
                    this.dialogRef.close();
                });
            return;
        }
        this.snapshotService.applicationConfiguration.userProfiles.forEach((userProfile: UserProfile, index: number) => {
            if (this.generateProfileKey(userProfile) === this.selectedProfileKey) {
                this.appConfig.activeUserProfile = userProfile;
                this.applicationConfigurationService.saveLastAccessedUserProfileIndex(index);
            }
        });
        // Now restart to live mode
        this.dashboardEventService.profileSubject.next(this.appConfig.activeUserProfile);
        this.dashboardEventService.toggleSideBarSliderSubject.next(false);
        this.dialogRef.close();
    }

    generateProfileKey(userProfile: UserProfile): string {
        return userProfile.getProfileType + userProfile.getCurrencies().join('-');
    }
}
